import { ContainerPointRankingEntry } from 'models/ranking/pointRanking/entry/ContainerPointRankingEntry';

export class ContainerPointRankingEntryService {
	toModel(ranking) {
		return new ContainerPointRankingEntry(ranking);
	}
}
